const strings = {
  title: 'wurl',
  subtitle: 'Internal URL Shortener',
  inputLabel: 'Paste a URL to shorten, a short link to look up, or type a slug',
  inputPlaceholder: 'https://... or https://go.dev.wbd-us.com/... or my-slug',
  customSlugLabel: 'Custom slug (optional)',
  customSlugPlaceholder: 'my-link',
  submitShorten: 'Shorten',
  submitLookup: 'Look up',
  resultShortUrl: 'Short URL',
  resultLongUrl: 'Destination',
  copyButton: 'Copy',
  copiedButton: 'Copied!',
  signIn: 'Sign in to shorten URLs',
  errorDomainNotApproved: 'This domain is not on the approved list. Contact a Wurl Admin to add it.',
  errorConflict: 'That custom slug is already in use.',
  errorGeneral: 'Something went wrong. Please try again.',
  errorNotFound: 'Short link not found.',
};

export default strings;
